import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VueRouter from 'vue-router'
import routes from './router'
import upData from './config/updata.js'
import ElementUI from 'element-ui'
import Service from './config/service'
import Service2 from './config/service2'
import ToThousand from './config/numToThousand'
import ModifyPhone from './config/modifyPhone'
import VueI18n from 'vue-i18n'
import 'element-ui/lib/theme-chalk/index.css'
import './theme/pagination.css'
import './style/font-awesome/css/font-awesome.css'
import './config/jquery/jquery-1.9.1.min'
import './style/merge.css'
import VueLazyLoad from 'vue-lazyload'
import VueContentPlaceholders from 'vue-content-placeholders'
import zLoad from './components/loading/loading.js'
import * as filters from './filters'; // global filters


// 分页
import Pagination from "@/components/Pagination";
Vue.component('pagination', Pagination);
// 骨架屏
import zSkeleton from "@/components/skeleton";
Vue.component('zSkeleton', zSkeleton);
import store from "./store"
import configAuthMessage from './config/configAuthMessage.js'
// 处理ie8 9 10 axios
import 'babel-polyfill'

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
// 格式化保留两位小数
Vue.prototype.ToThousand = ToThousand
    // 格式化手机号为  130****1234
Vue.prototype.ModifyPhone = ModifyPhone
    // 曾经的axios请求封装  （确认待删除）
Vue.prototype.Service = Service
    // axios请求封装
Vue.prototype.Service2 = Service2
    // 全局更新监听
Vue.prototype.updataPoint = upData
    // vuex
Vue.prototype.store = store
    // 全局变量
Vue.prototype.configAuthMessage = configAuthMessage
    // Vue.prototype.zLoad = zLoad

Vue.use(zLoad) // 全局使用loading
Vue.use(VueAwesomeSwiper)
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(VueI18n)
Vue.use(VueLazyLoad, {
    preLoad: 1.3,
    error: require('../static/images/bg800.png'),
    loading: require('../static/images/bg800.png'),
    attempt: 1
})
Vue.use(VueContentPlaceholders)

const router = new VueRouter({
    mode: 'history',
    fallback: false,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

// 解决Loading chunk (\d)+ failed问题
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if(isChunkLoadFailed){
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
    location.reload();
    // const targetPath = $router.history.pending.fullPath;
    // $router.replace(targetPath);
  }

});
const i18n = new VueI18n({
    locale: localStorage.getItem('language') || 'zh-CN',
    messages: {
        EN: require('./config/EN.js'),
        'zh-CN': require('./config/zh-CN.js')
    }
})

function getUrlParam(name, url) {//解析地址参数
  let u = arguments[1] || window.location.href,
    reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"),
    r = u.substr(u.indexOf("?") + 1).match(reg);
  return r != null ? decodeURI(r[2]) : "";
}
// 判断是否需要登录权限 以及是否登录
router.beforeEach((to, from, next) => {
    // 存储当前跳转路径 （判断无需token的接口）
    sessionStorage.setItem('path', to.path)
    store.commit('urlPathChange', to.path)

    // 设置国际化
    store.commit('languageChange', '')
    store.commit('languageChangeEn', '')
    i18n.setLocaleMessage("zh-CN", store.state.messageCn);
    i18n.setLocaleMessage("EN", store.state.messageEn);


  let uuid = getUrlParam('uuid',location.href);
  if(uuid) {//单点登录进入
    console.log('存在uuid')
    Service2.getType("/api/approval/open/getToken", {
      key: uuid,
    }).then((res) => {
      if (res.code === 1001) {
        console.log('获取token成功')
        window.sessionStorage.setItem('uuid', res.result.token);
        next()
      }
    });
  }else{
    console.log('不存在uuid')
    next()
  }
})

Vue.config.productionTip = false



new Vue({
    router,
    i18n,
    store
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js